// HeroSection.jsx
import React from "react";
import "./heroSection.css";
import leads from "../../images/leads.png";
import carriers from "../../images/carriers.png";
import team from "../../images/team.png";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-top">
          {/* Make this feel more like a watermark / brand pillar */}

          <div className="hero-right">
            <h1 className="hero-title">
              Welcome to the <br />
              <span className="hero-titleAccent">Reszko Nation</span>
            </h1>

            <h2 className="hero-subtitle">Where Ambition Meets Opportunity.</h2>

            <p className="hero-body">Built for those ready to lead at scale.</p>

            <button className="hero-btn">
              <a href="/contact">
                <p>Request an Interview</p>
              </a>
            </button>
          </div>
        </div>

        {/* Stat bar: consistent sizing + hierarchy */}
        <div className="hero-bottom">
          <div className="hero-stat">
            <div className="hero-stat-top">
              <img className="hero-icons" src={leads}></img>
              <div className="hero-statValue">
                <p>1000+</p>
              </div>
            </div>
            <div className="hero-statLabel">
              <p>New Leads Daily</p>
            </div>
          </div>

          <div className="hero-stat">
            <div className="hero-stat-top">
              <img className="hero-icons" src={carriers}></img>
              <div className="hero-statValue">
                <p>30+</p>
              </div>
            </div>
            <div className="hero-statLabel">
              <p>Top Carriers</p>
            </div>
          </div>

          <div className="hero-stat">
            <div className="hero-stat-top">
              <img className="hero-icons" src={team}></img>
              <div className="hero-statValue">
                <p>300+</p>
              </div>
            </div>
            <div className="hero-statLabel">
              <p>Agents</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
